import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import WhyItMatters from "../components/WhyItMatters";
import WhatWeDo from "../components/WhatWeDo";
import Verticals from "../components/Verticals";
import ServiceOffer from "../components/ServiceOffer";
import HowItWorks from "../components/HowItWorks";
import FAQAccordion from "../components/FAQAccordion";
import WhatsAppFab from "../components/WhatsAppFab";
import { useI18n } from "../i18n/I18nContext";
import { useSEO } from "../lib/seo";
import { ArrowRight } from "lucide-react";

export default function Home() {
  const { locale, t, routes } = useI18n();
  useSEO({
    title: locale === "fr"
      ? "SAFEMAT · Désinfection vapeur tatami & surfaces sportives en Suisse"
      : "SAFEMAT · Dampfdesinfektion Tatami & Sportbodenflächen in der Schweiz",
    description: t.hero.sub,
    locale,
  });

  return (
    <div data-testid="home-page" className="scroll-smooth">
      <Header />
      <main>
        <Hero />
        <WhyItMatters />
        <WhatWeDo />
        <Verticals />
        <ServiceOffer />
        <HowItWorks />
        <FAQAccordion />
        <section id="contact-cta" className="bg-slate-950 text-white" data-testid="contact-cta">
          <div className="max-w-5xl mx-auto px-5 lg:px-8 py-20 lg:py-24 text-center">
            <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] max-w-3xl mx-auto">
              {locale === "fr"
                ? "Prêt à sécuriser l'hygiène de vos surfaces ?"
                : "Bereit, die Hygiene Ihrer Flächen zu sichern?"}
            </h2>
            <p className="mt-5 text-slate-300 max-w-2xl mx-auto">
              {locale === "fr"
                ? "Demandez un devis gratuit. Réponse rapide par WhatsApp."
                : "Fragen Sie eine Gratis-Offerte an. Schnelle Antwort per WhatsApp."}
            </p>
            <div className="mt-8">
              <Link to={routes.quote} className="btn-primary inline-flex">
                {t.hero.cta} <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
